import { defineStore } from "pinia";

// TODO(S03): tipar com a entidade de usuário do @phurshell/psiapp-frontend-core
export const useSessionStore = defineStore("session", {
  state: (): { session: any | null } => ({ session: null }),
  persist: true,
  actions: {
    save(params: any) {
      this.session = params;
    },
    update(params: any) {
      // diferente do pro: mescla mesmo sem sessão, como a store única antiga fazia
      this.session = { ...(this.session || {}), ...params };
    },
    destroy() {
      this.session = null;
    },
  },
});
